const getEnvUrl = (
    productionUrl?: string,
    stagingUrl?: string,
    developmentUrl?: string
) =>
    process.env.REACT_APP_NODE_ENV === 'production'
        ? productionUrl
        : process.env.REACT_APP_NODE_ENV === 'staging'
        ? stagingUrl
        : developmentUrl;

const trimTrailingSlashes = (value?: string) => value?.replace(/\/+$/, '') || '';

export const getBaseUrl = () =>
    getEnvUrl(
        process.env.REACT_APP_PROD_API,
        process.env.REACT_APP_STAGING_API,
        process.env.REACT_APP_DEV_API
    );

export const buildApiUrl = (path = '') => {
    const baseUrl = trimTrailingSlashes(getBaseUrl());
    const normalizedPath = path.replace(/^\/+/, '');

    return normalizedPath ? `${baseUrl}/${normalizedPath}` : baseUrl;
};

export const getUploadUrl = () =>
    getEnvUrl(
        process.env.REACT_APP_PROD_UPLOAD_PATH,
        process.env.REACT_APP_STAGING_UPLOAD_PATH,
        process.env.REACT_APP_DEV_UPLOAD_PATH
    );
